<div class="delivery-component">
  <nz-spin nzTip="Loading..." [nzSpinning]="isSpinning">
    <div class="statistic-wrap gap-8 mb-8 flex sm:flex-col">
      <div *ngFor="let data of chartData;let i = index;" class="statistic cursor-pointer" class="statistic" [ngClass]="{ 'hover:bg-purpleBg': i==2, 'hover:bg-yellow100': i==0, 'hover:bg-green100': i==1}" [style.border-top]="'6px solid ' + data.color" (click)="handleStatus(data.status, data.label)">
        <div>
          <p [style.color]="data.color" class="font14-w500">{{ data.label }}</p>
          <p><span class="font-bold font18-w700">{{ data.value }}</span><span class="lines">({{'LINES' | translate}})</span></p>
        </div>
      </div>
    </div>
    <form [formGroup]="searchFormData">
      <div class="flex w-full flex-wrap gap-x-4 sm:flex-col">
        <div class="sm:w-full mx:w-[536px]">
          <nz-form-item class="search-form-item">
            <nz-form-control>
              <div class="flex">
                <div  class="mx:w-[260px]">
                  <nz-select class="bosch-select" formControlName="keywordsType" (ngModelChange)="changeKeywords()"
                    [nzSuffixIcon]="suffixSearch">
                    <nz-option *ngFor="let item of codeTypeList; let i = index" [nzValue]="item.value"
                      [nzLabel]="item.name"></nz-option>
                  </nz-select>
                  <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
                </div>
                <div  class="mx:w-[260px] ml-4">
                  <nz-input-group class="bosch_input" [nzSuffix]="suffixTemplateInfo">
                    <input (keydown.enter)="onInputEnter($event)" nz-input type="text" formControlName="keywords"
                      [placeholder]="(searchFormData.get('keywordsType')?.value === 'orderedMaterialNumber'?('PLACEHOLDER_MATERIAL' | translate):('PLEASE_INPUT' | translate))" />
                    <ng-template #suffixTemplateInfo>
                      <i class="search" (click)="handleChange($event)"></i>
                    </ng-template>
                  </nz-input-group>
                </div>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="sm:w-full mx:w-[260px]">
          <nz-form-item class="search-form-item">
            <nz-form-control>
              <nz-select class="bosch-select" formControlName="deliveryStatusList" (ngModelChange)="handleChange($event)"
                [nzSuffixIcon]="suffixSearch" nzMode="multiple" [nzMaxTagCount]="1" [nzShowSearch]="false" nzAllowClear
                [nzShowArrow]="true" [nzPlaceHolder]="'DELIVERY_STATUS' | translate">
                <nz-option *ngFor="let item of statusList; let i = index" [nzValue]="item.value" [nzLabel]="item.name">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="sm:w-full mx:w-[260px]">
          <nz-form-item class="search-form-item">
            <nz-form-control>
              <nz-select class="bosch-select" [nzOptionHeightPx]="142" [nzFilterOption]="filterOption" [nzOptionOverflowSize]="2" nzShowSearch formControlName="shipTo"
                (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixSearch" nzAllowClear [nzPlaceHolder]="'CART_SHIPPING_ADDRESS' | translate">
                <nz-option nzCustomContent [nzLabel]="shippingAddress.customerName"
                  [nzValue]="shippingAddress" *ngFor="let shippingAddress of shippingAddressList">
                  <div class="adrress-item">
                    <p class="font-bold">{{shippingAddress.customerName}}</p>
                    <p>{{shippingAddress.street}}</p>
                    <p>{{shippingAddress.postalCode}} {{shippingAddress.city}}</p>
                    <p>{{shippingAddress.country}} {{shippingAddress.region}}</p>
                    <p>{{shippingAddress.mobilePhone}}</p>
                    <p>{{shippingAddress.customerCode}}</p>
                  </div>
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="sm:w-full mx:w-[260px]">
          <nz-form-item class="search-form-item">
            <nz-form-control>
              <nz-range-picker [nzSuffixIcon]="suffixDate" class="bosch-date-picker w-full" formControlName="orderDate" (ngModelChange)="handleChange($event)"></nz-range-picker>
              <ng-template #suffixDate><i class="search-date"></i></ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="sm:w-full mx:w-[260px]">
          <nz-form-item class="search-form-item">
            <nz-form-control>
              <nz-select class="bosch-select" formControlName="sortType" (ngModelChange)="handleChange($event)"
                [nzSuffixIcon]="suffixSearch">
                <nz-option *ngFor="let item of sortList; let i = index" [nzValue]="item.value" [nzLabel]="item.name">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="sm:w-full mx:w-[90px] flex">
          <button nz-button nzType="text" class="clear flex justify-center"  (click)="clear()">
            <svg-icon [iconName]="'new/close-blue.svg'" [size]="20" ></svg-icon> {{"CLEAR" | translate}}
          </button>
        </div>
        <div class="sm:w-full mx:w-[76px] flex" >
          <button nz-button nzType="text" class="mt-2" (click)="exportExcel()" [nzLoading]="exportLoading">
            <svg-icon [iconName]="'new/download.svg'" ></svg-icon>{{ "EXPORT" | translate}}
          </button>
        </div>
      </div>
    </form>
    <div class="result-table">
      <nz-table  [nzFrontPagination]="false" #fixedTable [nzScroll]="{ x: 'max-content' }"
        nzShowPagination [nzTotal]="pagination.total" [nzPageIndex]="pagination.pageIndex"
        [nzPageSize]="pagination.pageSize" [nzPageSizeOptions]="pagination.pageSizeOptions"
        (nzPageIndexChange)="handleChangeCurrentPage($event)" (nzPageSizeChange)="handleChangePageSize($event)"
        [nzData]="deliveryListData">
        <thead>
          <tr>
            <th nzWidth="135px">{{ "DELIVERY_NO" | translate}}</th>
            <th nzWidth="100px">{{ "DN_ITEM_NO" | translate}}</th>
            <th nzWidth="155px">{{ "MATERIA_NUM" | translate}}</th>
            <th nzWidth="105px">{{ "QUANTITY" | translate}}</th>
            <th nzWidth="160px">{{ "PLANNED_DELIVERY_DATE" | translate}}</th>
            <th nzWidth="140px">{{ "NET_PRICE" | translate}}</th>
            <th nzWidth="200px">{{ "NET_VALUE" | translate}}</th>
            <th nzWidth="180px">{{ "DELIVERY_STATUS" | translate}}</th>
            <th nzWidth="180px">{{ "TRACK_NUMBER" | translate}}</th>
            <th nzWidth="140px">{{ "INVOICE_NUMBER" | translate}}</th>
            <th nzWidth="160px">{{ "PO_No" | translate}}</th>
            <th nzWidth="120px">{{ "ORDER_NO" | translate}}</th>
            <th nzWidth="100px">{{ "ORDER_ITEM" | translate}}</th>
            <th nzWidth="150px">{{ "UPDATE_TIME_ORDER" | translate}}</th>
          </tr>
        </thead>
        <tbody class="order">
          <tr *ngFor="let data of deliveryListData">
            <td>{{ data.dnNo }}</td>
            <td>
              {{ data.dnItemNo }}
            </td>
            <td>
              <div class="delivery-good">
                <div>
                  <div class="font-bold">{{ data.orderedMaterialNumber }}</div>
                  <div>{{ data.enteredMaterialNumber }}</div>
                  <div>{{ data.productDescription }}</div>
                </div>
              </div>
            </td>
            <td>{{ data.dnQuantity }}</td>
            <td>{{ data.dnCreateDate }}</td>

            <td>{{data.currency}} {{data.unitPrice | number : "1.2-2" }}</td>
            <td>{{data.currency}} {{data.totalNetValue | number : "1.2-2" }}</td>
            <td>
              <custom-tag [content]="data.realDeliveryStatusDisplayName"
                [backgroundColor]="getColorByStatus(data.realDeliveryStatus,true,false)"
                [fontColor]="getColorByStatus(data.realDeliveryStatus,false,false)"
                [borderColor]="getColorByStatus(data.realDeliveryStatus,false,true)"></custom-tag>
            </td>
            <td>
              <div class="link" (click)="goTracking(data.trackingNo)">{{ data.trackingNo }}</div>
            </td>
            <td>{{ data.billingNo }}</td>
            <td>
              <div class="po_number">{{data.poNo}}</div>
            </td>
            <td>
              <div class="link" (click)="goPage('order/detail',data.orderNo)">
                {{ data.orderNo }}
              </div>
            </td>
            <td>
              {{ data.itemNo }}
            </td>
            <td>
              {{ data.batch }}
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #totalTemplate let-total>{{
        "TOTAL_ITEM" | translate : { total }
        }}</ng-template>
    </div>
  </nz-spin>
</div>